import { render } from "./B2bPageFacturasEmitidas.vue?vue&type=template&id=60311d50&scoped=true&lang=pug"
import script from "./B2bPageFacturasEmitidas.vue?vue&type=script&lang=js"
export * from "./B2bPageFacturasEmitidas.vue?vue&type=script&lang=js"

import "./B2bPageFacturasEmitidas.vue?vue&type=style&index=0&id=60311d50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60311d50"]])

export default __exports__